import { render, staticRenderFns } from "./UserBaseData.vue?vue&type=template&id=a76acbfa"
import script from "./UserBaseData.vue?vue&type=script&lang=js"
export * from "./UserBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports